(function() {
  var SelectBox, ValidationEngine,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  SelectBox = App.loadClass('core::SelectBox');

  ValidationEngine = App.loadClass('core::ValidationEngine');

  exports.Contracts_Contract_Dialog_Handler = (function(superClass) {
    extend(Contracts_Contract_Dialog_Handler, superClass);

    function Contracts_Contract_Dialog_Handler() {
      return Contracts_Contract_Dialog_Handler.__super__.constructor.apply(this, arguments);
    }

    Contracts_Contract_Dialog_Handler.prototype.init = function() {
      this.layoutUrl = 'backend/portal/contracts/load-layout-contract-dialog';
      this.saveUrl = 'backend/portal/contracts/save-contract';
      this.savingBtnMsg = 'Saving Contract...';
      this.destroyOnSave = false;
      this.slideFormUp = false;
      this.refreshNavHandler = true;
      this.createDialog();
      return this.validator = new ValidationEngine();
    };

    Contracts_Contract_Dialog_Handler.prototype.getPostData = function() {
      var data;
      data = {
        id: $('#contract_id').val(),
        number: $('#contract_number').val().replace(/\s-\s/g, ''),
        year: $('#contract_year').val(),
        zone: $('#sales_zone').val(),
        fields: $('#sel_contracted_fields>option').map(function(i, el) {
          return el.value;
        }).get()
      };
      return JSON.stringify(data);
    };

    Contracts_Contract_Dialog_Handler.prototype.afterLoadLayout = function(selector, response) {
      var ref, ths;
      this.openDialog();
      if (((ref = response.status) != null ? ref.type : void 0) !== 'success') {
        return;
      }
      ths = this;
      if (this.parent.currMode === 'Edit') {
        this.parent.disableDialogForm();
      }
      this.dialog.find('#sel_grower').bind('change', (function(_this) {
        return function() {
          return _this.updateFields();
        };
      })(this));
      this.dialog.find('#btn_add_fields').bind('click', (function(_this) {
        return function() {
          _this.moveOptions($('#sel_fields'), $('#sel_contracted_fields'));
          return _this.updateTotalAcres();
        };
      })(this));
      this.dialog.find('#btn_remove_fields').bind('click', (function(_this) {
        return function() {
          var uid;
          _this.moveOptions($('#sel_contracted_fields'), $('#sel_fields'));
          uid = $('#sel_grower').val();
          $('#sel_fields').find('option[data-uid!="' + uid + '"]').remove();
          return _this.updateTotalAcres();
        };
      })(this));
      $('#contract_year').unbind().bind('change', function() {
        return ths.updateFields();
      });
      this.validator.makeFormValidator('contracts_dialog', '#form_contracts_dlg', '#contracts_dialog_errors', (function(_this) {
        return function(valid) {
          if (valid) {
            return _this.save('Saving Contract...');
          }
        };
      })(this));
      return this.validator.registerRule({
        'selector': '.validate-contracted-fields',
        'text': 'You must add at least one field to the contract',
        'func': function(elem) {
          return $(elem).find('option').length > 0;
        }
      });
    };

    Contracts_Contract_Dialog_Handler.prototype.submitAction = function() {
      return this.parent.validator.validateForm('contracts_sidebar');
    };

    Contracts_Contract_Dialog_Handler.prototype.updateFields = function() {
      var elem, field, fields, filter, j, k, len, len1, ref, uid, val, year_field;
      uid = $('#sel_grower').val();
      filter = {};
      filter.uid = {
        '==': parseInt(uid)
      };
      fields = this.taffyObjects['fields'](filter).order('fname').distinct('fid', 'fname');
      SelectBox.render(fields, $('#sel_fields'), []);
      ref = $('#sel_fields option');
      for (j = 0, len = ref.length; j < len; j++) {
        elem = ref[j];
        elem = $(elem);
        val = elem.val();
        if ($('#sel_contracted_fields option[value="' + val + '"]').length) {
          elem.remove();
        } else {
          field = this.taffyObjects['fields']({
            'fid': {
              '==': val
            }
          }).select('uname', 'year_contracts', 'year');
          this.configureFieldElem(elem);
          for (k = 0, len1 = field.length; k < len1; k++) {
            year_field = field[k];
            if ((year_field[2] != null) && year_field[2].toString() === $('#contract_year').val().toString() && year_field[1] > 0) {
              elem.css({
                color: '#bbbbbb'
              });
              elem.attr('disabled', 'disabled');
              break;
            }
          }
        }
      }
      return $('#sel_fields option').tooltip();
    };

    Contracts_Contract_Dialog_Handler.prototype.configureFieldElem = function(elem) {
      var field;
      field = this.taffyObjects['fields']({
        'fid': {
          '==': elem.val()
        }
      }).select('uname', 'uid', 'tillable_acres');
      elem.attr('title', field[0][0]);
      elem.attr('data-uid', field[0][1]);
      return elem.attr('data-acres', field[0][2]);
    };

    Contracts_Contract_Dialog_Handler.prototype.loadFields = function() {
      var elem, fid, field, filter, j, len, ref;
      $('#sel_contracted_fields').empty();
      ref = $('input[name="contract_field"]');
      for (j = 0, len = ref.length; j < len; j++) {
        elem = ref[j];
        fid = $(elem).val();
        filter = {
          'fid': {
            '==': parseInt(fid)
          }
        };
        field = this.taffyObjects['fields'](filter).select('fname', 'uname', 'tillable_acres');
        elem = $("<option value='" + fid + "'>" + field[0][0] + "</option>");
        this.configureFieldElem(elem);
        $('#sel_contracted_fields').append(elem);
      }
      this.updateTotalAcres();
      return $('#sel_contracted_fields option').tooltip();
    };

    Contracts_Contract_Dialog_Handler.prototype.disableForm = function() {
      return this.dialog.find('select, span.btn').attr('disabled', 'disabled');
    };

    Contracts_Contract_Dialog_Handler.prototype.enableForm = function() {
      return this.dialog.find('select, span.btn').removeAttr('disabled');
    };

    Contracts_Contract_Dialog_Handler.prototype.updateTotalAcres = function() {
      var acres, elem, j, len, ref, totacres;
      totacres = 0;
      ref = $('#sel_contracted_fields option');
      for (j = 0, len = ref.length; j < len; j++) {
        elem = ref[j];
        acres = $(elem).data('acres');
        totacres += parseFloat(acres);
      }
      return $('#span_total_acres').text(totacres.toFixed(1));
    };

    return Contracts_Contract_Dialog_Handler;

  })(FullPageHandler);

}).call(this);
